import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";
import "./LG.css";

const LGWashingPageTemplate = ({
  title,
  description,
  keywords,
  path,
  bannerTitle,
  intro,
  highlights = [],
  issueTitle = "Common Issues We Fix",
  issues = [],
  relatedLinks = [],
}) => {
  const canonicalUrl = `https://customersupports24x7.in${path}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta
          property="og:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta
          name="twitter:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <div className="lg-banner-wrapper">
        <InnerBanner
  title={bannerTitle}
  bgImage={serviceBg}
  brand="lg"
/>
      </div>

      <div className="lg-page brand-page">
        <p style={{ textAlign: "justify" }}>
          {typeof intro === 'string' ? intro : intro}
        </p>

        <div className="card">
          <h2>What Our Technicians Support</h2>
          <ul style={{ textAlign: "justify" }}>
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="card">
          <h2>{issueTitle}</h2>
          <ul style={{ textAlign: "justify" }}>
            {issues.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="card">
          <h2>LG Washer Repair & Service pages</h2>
          <div className="links">
            {relatedLinks.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="cta-box">
          <h3>Book LG Washing Machine Service</h3>
          <p style={{ color: "#ffffff", textAlign: "center", fontSize: "18px" }}>
            Call now to schedule LG washing machine repair at your doorstep
            anywhere in Bangalore.
          </p>

          <a href="tel:8050731754">
            <button className="call-btn">Call Now</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default LGWashingPageTemplate;
